exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".modal{display:flex;align-items:center}.modal,.overlay{width:100%;height:100%;position:fixed;left:0;top:0}.overlay{opacity:.5;background-color:#000}.modal-card{width:398px;height:auto;margin:auto;background-color:#fff;border-radius:4px;z-index:10;opacity:1}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-6bf8d164","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/contents/shared/ModalView.vue
// module id = 355
// module chunks = 0